import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/rice/xtable-pos-v3/layouts/default.vue").then(m => m.default || m)),
  expire: defineAsyncComponent(() => import("/Users/rice/xtable-pos-v3/layouts/expire.vue").then(m => m.default || m)),
  splash: defineAsyncComponent(() => import("/Users/rice/xtable-pos-v3/layouts/splash.vue").then(m => m.default || m))
}